import { capitalize } from '@gonfalon/strings/capitalize';
import { has, isEmpty } from 'lodash';

import type { FilterValue } from '#components/ui/multipleFilters/types';
import { FilterKind } from '#components/ui/multipleFilters/types';
import type {
  BackendQueryParamName,
  FlagFilterInterface,
  QueryParamName,
} from '#utils/flagFilters/flagFilterInterface';
import { FilterOperator, FlagListBackendQueryParam, FlagListQueryParam } from '#utils/flagFilters/types';

export enum FlagTypeOption {
  TEMPORARY = 'temporary',
  PERMANENT = 'permanent',
}

const flagTypeOptionDisplayNames: Record<FlagTypeOption, string> = {
  temporary: 'Temporary',
  permanent: 'Permanent',
};

export class TypeFilter implements FlagFilterInterface<string> {
  name: string;
  value?: string;
  kind: FilterKind;
  queryParamName: QueryParamName;
  backendQueryParamName: BackendQueryParamName;
  operators: string[];
  defaultValue: string;

  constructor(value?: string) {
    this.name = 'Type';
    this.value = value;
    this.kind = FilterKind.TYPE;
    this.queryParamName = FlagListQueryParam.TYPE;
    this.backendQueryParamName = FlagListBackendQueryParam.TYPE;
    this.operators = [FilterOperator.IS];
    this.defaultValue = FlagTypeOption.TEMPORARY;
  }

  getFilterValueDisplayName(value?: FilterValue) {
    if (!value) {
      return '';
    }
    return capitalize(value as string);
  }

  getDisplayName = () => this.name;

  getOptions() {
    return Object.entries(flagTypeOptionDisplayNames).map(([value, label]) => ({
      label,
      name: label,
      value,
      filterOption: this.kind,
      isChecked: this.value === value,
    }));
  }

  isEnabled = () => true;

  isEmpty = () => isEmpty(this.value);

  toQuery = () => this.value;

  isInvalidFilter = () => !this.isEmpty() && !has(flagTypeOptionDisplayNames, this.value ?? '');

  clearFilter = () => (this.value = undefined);

  toBackendQuery() {
    if (this.isEmpty()) {
      return '';
    }
    return `type:${this.value}`;
  }

  parseFilterParam(queryParts: string[]) {
    const [, value] = queryParts;
    return value;
  }

  getFilterData() {
    return {
      operators: this.operators,
      options: this.getOptions(),
      defaultValue: this.defaultValue,
    };
  }
}
